import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Empty, Table } from 'antd'
import useLandingPageHooks from 'src/Hooks/MentorHooks/useLandingPageHooks'
import { academicYearLabel } from 'src/Common/academicYear'
import FinalStudentReport from 'src/Pages/CounselorPages/Student Enrollment/Students/StudentChildComponent/ViewDetail'
import 'src/Pages/LibraryPages/librarypages.scss'

const MentorGroupDetail = () => {
  const { groupDetail, loading, projectAssigned } = useLandingPageHooks()
  const { groupId } = useParams()
  const navigate = useNavigate()

  const [isDetailView, setIsDetailView] = useState(false)
  const [selectedReport, setSelectedReport] = useState(null)

  const viewDetail = (record) => {
    setSelectedReport({
      studentId: record.studentId,
      careerPathReportId: record.careerPathReportId,
    })
    setIsDetailView(true)
  }

  const Back = () => {
    setIsDetailView(false)
  }

  const columns = [
    {
      title: 'Student ID',
      key: 'studentId',
      render: (_, record) => record.studentPublicId || record.studentId,
    },
    {
      title: 'Student Name',
      dataIndex: 'studentName',
      key: 'studentName',
    },
    {
      title: 'Academic Year',
      dataIndex: 'academicYear',
      key: 'academicYear',
      // api-dev2: academicYear is a numeric AcademicYearEnum (string still shows via fallback).
      render: (v) => academicYearLabel(v) || v,
    },
    {
      title: 'View Career Path Report',
      key: 'hasCareerPathReport',
      render: (_, record) =>
        record.hasCareerPathReport ? (
          <button type="button" className="lpg__btn-ghost" onClick={() => viewDetail(record)}>
            View Detail
          </button>
        ) : (
          'N/A'
        ),
    },
  ]

  const handleManageClick = (id) => {
    navigate(`/projects-Detail/${id}`) // Navigate with project ID
  }

  return (
    <>
      {isDetailView ? (
        <FinalStudentReport
          studentId={selectedReport.studentId}
          careerPathReportId={selectedReport.careerPathReportId}
          Back={Back}
        />
      ) : (
        <div className="lpg">
          <style>{`
            .mgd-sect { margin-bottom: 18px; }
            .mgd-sect:last-child { margin-bottom: 0; }
            .mgd-sect__title { display:flex; align-items:center; gap:9px; margin:0 0 16px;
              color:#16233f; font-size:1.02rem; font-weight:800; letter-spacing:-0.01em; }
            .mgd-sect__title::before { content:''; flex:none; width:4px; height:18px; border-radius:999px;
              background:linear-gradient(180deg,#3b82f6,#2563eb); }
            .mgd-kv { display:grid; grid-template-columns:max-content 1fr; gap:12px 20px; }
            .mgd-kv__k { color:#6b7794; font-size:0.75rem; font-weight:700; text-transform:uppercase;
              letter-spacing:0.05em; padding-top:2px; }
            .mgd-kv__v { color:#16233f; font-size:0.92rem; line-height:1.55; }
            @media (max-width:560px){
              .mgd-kv { grid-template-columns:1fr; gap:4px 0; }
              .mgd-kv__k { margin-top:10px; }
              .mgd-kv__k:first-child { margin-top:0; }
            }
          `}</style>
          <div className="lpg__head">
            <div className="lpg__head-main">
              <span className="lpg__head-ic">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </span>
              <div>
                <h1 className="lpg__title">Group Detail</h1>
                <p className="lpg__sub">Group members and progress.</p>
              </div>
            </div>
            <button
              type="button"
              className="lpg__back"
              onClick={() => navigate('/mentor-Dashboard')}
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M19 12H5M11 18l-6-6 6-6" />
              </svg>{' '}
              Back
            </button>
          </div>

          {loading ? (
            <div className="lpg__state">
              <div className="lpg__spin" />
              Loading...
            </div>
          ) : (
            <>
              <div className="lpg__panel-box mgd-sect">
                <div className="lpg__toolbar">
                  {projectAssigned ? (
                    <button
                      type="button"
                      className="lpg__btn-primary"
                      onClick={() => handleManageClick(groupDetail.projectId)}
                    >
                      View Project
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="lpg__btn-primary"
                      onClick={() => navigate(`/assign-internship-project/${groupId}`)}
                    >
                      Assign Project
                    </button>
                  )}
                </div>

                {groupDetail ? (
                  <>
                    <h3 className="mgd-sect__title">Group Information</h3>
                    <div className="mgd-kv">
                      <span className="mgd-kv__k">Group Name</span>
                      <span className="mgd-kv__v">{groupDetail.groupName || 'N/A'}</span>

                      <span className="mgd-kv__k">Created At</span>
                      <span className="mgd-kv__v">
                        {groupDetail.createdAt
                          ? new Date(groupDetail.createdAt).toLocaleString()
                          : 'N/A'}
                      </span>
                    </div>
                  </>
                ) : (
                  <Empty description="No group details found" />
                )}
              </div>

              {groupDetail && (
                <div className="lpg__panel-box mgd-sect">
                  <h3 className="mgd-sect__title">Group Members</h3>
                  <Table dataSource={groupDetail.members} columns={columns} rowKey="memberId" />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </>
  )
}

export default MentorGroupDetail
